import { UbisoftIcon } from './UbisoftIcon';

/**
 * author: Contributors
 * id F8C3B22E-D72C-4A1C-BCB8-A24CBB3CAF46
 * name ubisoft
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ubisoft.svg
 * tags
 * - Brand / Logo 
 * - Gaming / RPG 
 */
export const UplayIcon = UbisoftIcon;
export default UplayIcon